import Fuse from 'fuse.js';

type MentionSearchOption = {
  label: string;
  referenceId?: string;
  group?: string;
  subgroup?: string;
  providerLabel?: string;
  typeLabel?: string;
};

const MENTION_FUSE_KEYS: Array<keyof MentionSearchOption> = [
  'label',
  'referenceId',
  'group',
  'subgroup',
  'providerLabel',
  'typeLabel',
];

const MENTION_FUSE_THRESHOLD = 0.35;

const normalizeQuery = (query: string): string => query.trim();

export const createMentionFuzzyFilter = <T extends MentionSearchOption>(
  options: T[]
): ((query: string) => T[]) => {
  const fuse = new Fuse(options, {
    keys: MENTION_FUSE_KEYS,
    threshold: MENTION_FUSE_THRESHOLD,
    ignoreLocation: true,
  });

  return (query: string): T[] => {
    const normalizedQuery = normalizeQuery(query);
    if (normalizedQuery.length === 0) {
      return options;
    }
    return fuse.search(normalizedQuery).map((result) => result.item);
  };
};

export const fuzzyFilterMentionOptions = <T extends MentionSearchOption>(
  options: T[],
  query: string
): T[] => createMentionFuzzyFilter(options)(query);
